module.exports = __webpack_public_path__ + "static/media/scr_onboarding_dynamic_03_b.6e87f7de.png";